import {
  HomeRegular,
  FolderRegular,
  WifiSettingsRegular,
  DeleteRegular,
} from '@fluentui/react-icons';

/**
 * Primary nav destinations (HTS app-shell standard — Site Survey section):
 * Home · Projects · P2P Wireless · Trash render inline in the 72px rail.
 * The rail used to be 3 items; Trash is added so deleted folders are
 * always one click away (no flyout, no menu, no command-palette hop).
 * Shared by NavRail and the mobile drawer in Header. `/devices` is
 * intentionally not listed (per the standard's grouping audit).
 */
export interface NavItem {
  path: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}

export const NAV_ITEMS: NavItem[] = [
  { path: '/', label: 'Home', icon: HomeRegular },
  { path: '/projects', label: 'Projects', icon: FolderRegular },
  { path: '/p2p', label: 'P2P Wireless', icon: WifiSettingsRegular },
  { path: '/trash', label: 'Trash', icon: DeleteRegular },
];

export function isNavItemActive(pathname: string, itemPath: string): boolean {
  return itemPath === '/' ? pathname === '/' : pathname.startsWith(itemPath);
}
